<section class="panel p-4 mt-3" *ngIf="empregadorId">
  <h3 class="h6 mb-3">Secretário / Secretária</h3>
  <p class="text-secondary small">
    O nome e a secretaria entram no rodapé da portaria de férias. Cadastre a secretaria em Férias &gt; Secretarias.
  </p>
  <form class="row g-3" (ngSubmit)="salvar()">
    <div class="col-md-5">
      <label class="form-label">Secretaria</label>
      <select class="form-select" name="secretarioSecretaria" [(ngModel)]="formulario.secretariaId" required>
        <option value="">Selecione</option>
        <option *ngFor="let item of secretarias" [value]="item.id">{{ item.nome }}</option>
      </select>
    </div>
    <div class="col-md-5">
      <label class="form-label">Nome</label>
      <input class="form-control" name="secretarioNome" [(ngModel)]="formulario.nome" required>
    </div>
    <div class="col-md-2 d-flex align-items-end">
      <button class="btn btn-primary w-100" type="submit">Salvar</button>
    </div>
  </form>

  <div class="table-responsive mt-3" *ngIf="secretarios.length; else semSecretario">
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Secretaria</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of secretarios">
          <td>{{ item.nome }}</td>
          <td>{{ item.secretariaNome }}</td>
          <td class="text-end">
            <button type="button" class="btn btn-outline-secondary btn-sm me-1" (click)="editar(item)">Editar</button>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="excluir(item)">Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #semSecretario>
    <p class="text-secondary small mb-0 mt-3">Nenhum secretário cadastrado.</p>
  </ng-template>
</section>
